import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {
  e2eLocators,
  fakeSecretKey
} from '@components/storage-accounts/add-storage-account-wizard/credential-forms/credential-forms.constants';
import { I18NextPipe } from 'angular-i18next';
import { CardGroupComponent, CheckboxComponent, FormGroupComponent, InputComponent, InputPasswordComponent } from 'mbs-ui-kit';
import { StorageType } from 'mbs-ui-shared';
import { SFTPCredentialForm } from '../credential-forms.model';

@Component({
  selector: 'mbs-credential-form-sftp',
  templateUrl: './credential-form-sftp.component.html',
  styleUrls: ['../credential-forms.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CardGroupComponent,
    CheckboxComponent,
    CommonModule,
    FormGroupComponent,
    I18NextPipe,
    InputComponent,
    InputPasswordComponent,
    ReactiveFormsModule
  ]
})
export class CredentialFormSftpComponent {
  @Input() form: SFTPCredentialForm;

  protected readonly fakeSecretKey = fakeSecretKey;
  protected readonly StorageType = StorageType;
  protected readonly e2eLocators = e2eLocators;

  get user(): FormControl {
    return this.form.get('user') as FormControl;
  }

  get password(): FormControl {
    return this.form.get('password') as FormControl;
  }

  get endpoint(): FormControl {
    return this.form.get('endpoint') as FormControl;
  }

  get isPrivateStorage(): FormControl {
    return this.form.get('isPrivateStorage') as FormControl;
  }

  get keepAlive(): FormControl {
    return this.form.get('keepAlive') as FormControl;
  }
}
